module.exports = __webpack_public_path__ + "static/media/9DESA34.081c8d9d.jpg";